<template>
  <div>
    <h1>Switch 开关</h1>
    <p class="page-desc">
      表示两种相互对立的状态间的切换，多用于触发「开/关」。
    </p>

    <k-row gutter="16">
      <k-col span="24" :xl="{ span: 12 }">
        <demo-viewer title="基本用法" :code="JCYF" desc="最简单的用法。">
          <p>
            <k-switch v-model="value" @on-change="handleChange"></k-switch>
          </p>
        </demo-viewer>
        <demo-viewer title="文字和图标" :code="WZHTB" desc="自定义内容。">
          <p>
            <k-switch>
              <span slot="open">ON</span>
              <span slot="close">OFF</span>
            </k-switch>
          </p>
          <p>
            <k-switch>
              <k-icon slot="open" type="check"></k-icon>
              <k-icon slot="close" type="close"></k-icon>
            </k-switch>
          </p>
        </demo-viewer>
      </k-col>
      <k-col span="24" :xl="{ span: 12 }">
        <demo-viewer title="不可用" :code="BKY" desc="Switch 失效状态。">
          <p>
            <k-switch disabled></k-switch>
          </p>
        </demo-viewer>
        <demo-viewer
          title="加载状态"
          :code="JZZT"
          desc="标识开关操作仍在执行中。"
        >
          <p>
            <k-switch loading></k-switch>
          </p>
        </demo-viewer>
      </k-col>
    </k-row>

    <table class="doc-table">
      <caption>
        <h3>属性 props</h3>
      </caption>
      <thead>
        <tr>
          <th>参数</th>
          <th>说明</th>
          <th>类型</th>
          <th>默认值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>value</td>
          <td>指定当前是否选中，可以使用 v-model 双向绑定数据</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
        <tr>
          <td>disabled</td>
          <td>禁用开关</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
        <tr>
          <td>loading</td>
          <td>加载中的开关</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
      </tbody>
    </table>

    <table class="doc-table">
      <caption>
        <h3>事件 events</h3>
      </caption>
      <thead>
        <tr>
          <th>事件名</th>
          <th>说明</th>
          <th>返回值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>on-change</td>
          <td>开关变化时触发，返回当前的状态</td>
          <td>true | false</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: false,
      JCYF:
        `
  <template>
    <k-switch v-model="value" @on-change="handleChange"></k-switch>
  </template>
  <script>
    export default {
      data () {
        return {
          value: false
        }  
      },
      methods: {
        handleChange(status) {
          this.$Message("Changed! status：" + status);
        }
      }
    }
  </` +
        `script>
      `,
      BKY: `
  <template>
    <k-switch disabled></k-switch>
  </template>
      `,
      WZHTB: `
  <template>
    <k-switch>
      <span slot="open">ON</span>
      <span slot="close">OFF</span>
    </k-switch>
    <k-switch>
      <k-icon slot="open" type="check"></k-icon>
      <k-icon slot="close" type="close"></k-icon>
    </k-switch>
  </template>
      `,
      JZZT: `
  <template>
    <k-switch loading></k-switch>
  </template>
      `
    };
  },
  methods: {
    handleChange(status) {
      this.$Message("Changed! status：" + status);
    }
  }
};
</script>
